import "./About.scss";
import kerol from "../../assets/images/people/Kerol.jpg";

const About = () => (
  <section className="about" id="aboutUs">
    <div className="aboutPage" data-aos="fade-up">
      {/* Coluna da Imagem */}
      <div className="about-image" data-aos="fade-right">
        <img src={kerol} alt="Kerolyn Bernardi" />
      </div>

      {/* Coluna do Texto */}
      <div className="about-text" data-aos="fade-left">
        <div>
          <p>
            Sou <strong>Kerolyn Bernardi</strong>,{" "}
            <strong>terapeuta corporal</strong>, especializada em massagens e
            técnicas terapêuticas que promovem
            <strong> equilíbrio físico, emocional e energético</strong>.
          </p>
          <p>
            Meu propósito é{" "}
            <strong>
              ajudar pessoas a aliviar sintomas de estresse, ansiedade e
              depressão
            </strong>
            , oferecendo atendimentos que unem{" "}
            <strong>toque terapêutico, respiração e movimentos </strong>
            que favorecem a liberação de tensões e bloqueios emocionais.
          </p>
        </div>

        <div className="valores">
          <h3>O que você encontra nos atendimentos</h3>
          <ul>
            <li data-aos="fade-right">
              <strong>Revitalização da energia</strong> - para recuperar
              disposição e vitalidade.
            </li>
            <li data-aos="fade-right">
              <strong>Alívio de dores e tensões físicas</strong> - trazendo mais
              leveza ao corpo.
            </li>
            <li data-aos="fade-right">
              <strong>Liberação de bloqueios emocionais</strong> - favorecendo
              equilíbrio interno e bem-estar.
            </li>
          </ul>
        </div>

        <div>
          <p>
            Acredito que o corpo guarda histórias e emoções, e que, quando
            acolhidas e trabalhadas, podem se transformar em{" "}
            <strong>força, leveza e qualidade de vida</strong>. Cada atendimento
            é <strong>único e personalizado</strong>, pensado para criar um
            espaço seguro de <strong>acolhimento, escuta e reconexão</strong>.
          </p>
        </div>
      </div>
    </div>
  </section>
);

export default About;
